import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { resumeSubscription } from 'src/services/subscriptionApi'

export const useResumeSubscriptionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: resumeSubscription,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_SUBSCRIPTION_STATUS],
      })
    },
  })
}
